// extracted by mini-css-extract-plugin
export default {"icons":"DispalyexpenseItems_icons__35BwK","editexpenses":"DispalyexpenseItems_editexpenses__OzUeX","deleteexpense":"DispalyexpenseItems_deleteexpense__Yi97b"};